import React, { useEffect, useState } from "react";
import { Button, Card, Col, Flex, Form, Image, Input, Row } from "antd";
import { useAuth } from "AuthContext";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Title from "antd/es/skeleton/Title";

const onFinishFailed = (error) => {
    console.log(error);
};

export default function Login() {
    const { user, login } = useAuth();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (user) {
            navigate(searchParams.get("next") || "/");
        }
    }, [user, navigate, searchParams])
    return (
        <Row
            align="middle"
            justify="center"
            style={{ minHeight: "calc(100vh - 64px)", padding: 16 }}
        >
            <Col xs={24} sm={20} md={16} lg={10} xl={8}>
                <Card
                    bordered
                    style={{ borderRadius: 8 }}
                    bodyStyle={{ padding: 32 }}
                >
                    <Row justify="space-between" align="middle">
                        <Title level={4} style={{ margin: 0 }}>
                            Đăng nhập
                        </Title>
                        <Image
                            src={process.env.PUBLIC_URL + "/img/logo.png"}
                            width={60}
                            preview={false}
                            alt="logo"
                        />
                    </Row>

                    <div>Đăng nhập vào hệ thống học tập</div>

                    <Form
                        name="login"
                        layout="vertical"
                        className="mt-3"
                        initialValues={{ remember: true }}
                        onFinish={(values) => {
                            if (loading) return;
                            delete values.remember;
                            login(values, setLoading);
                        }}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        style={{ marginTop: 24 }}
                    >
                        <Form.Item
                            label="Tên đăng nhập hoặc email"
                            name="username"
                            rules={[{ required: true, message: "Nhập tên đăng nhập!" }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Mật khẩu"
                            name="password"
                            rules={[{ required: true, message: "Nhập mật khẩu!" }]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Flex justify="space-between" align="center" style={{ marginBottom: 12 }}>
                            <Link to="/forget-password">Quên mật khẩu</Link>
                        </Flex>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                                block
                            >
                                Vào
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Col>
        </Row>
    );
}
